// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LnYM","comment":"styles_comment__1h_2V"};